/* eslint-disable no-unused-vars */
import {
  Button,
  Col,
  DatePicker,
  Input,
  Modal,
  Row,
  Table,
  Typography,
  notification,
} from "antd";

import React, { useEffect, useRef, useState } from "react";
import { Panel, PanelBody, PanelHeader } from "../../../../util/panel";
import moment from "moment";
import SelectOption from "../../../pos/components/SelectOption";
import { useHttp } from "../../../../../hooks/http";
import { getToken, URL_API } from "../../../../../utils";

const { Text } = Typography;
const { Search } = Input;
const limit = 10;
const pageSize = 20;

const History = () => {
  const [transTypeFilter, setTransTypeFilter] = useState("");
  const [page, setPage] = useState(1);
  const [date_from, setDateFrom] = useState(moment());
  const [date_to, setDateTo] = useState(moment());
  const [search, setSearch] = useState("");

  const transTypeOptions = [
    { value: "", text: "ทั้งหมด" },
    { value: "reserve", text: "จองคะแนน" },
    { value: "cancel", text: "ยกเลิกการจอง" },
    { value: "bill", text: "ปลดล็อค-เปิดบิล" },
  ];

  const [loading, data, error, reload] = useHttp(
    {
      url: `${URL_API}/point/rp/reserve-log`,
      token: true,
      params: {
        limit,
        offset: limit * (page - 1),
        query: search,
        date_from: date_from ? moment(date_from).format("YYYY-MM-DD") : null,
        date_to: date_to ? moment(date_to).format("YYYY-MM-DD") : null,
        trans_type_filter: transTypeFilter,
      },
      initialLoad: true,
    },
    [search, date_from, date_to, transTypeFilter]
  );

  return (
    <Panel>
      <PanelHeader>ประวัติการจองคะแนน</PanelHeader>
      <PanelBody>
        <Row gutter={12} type="flex" className="align-items-center mb-3">
          <Col span={10}>
            <Search
              placeholder="ค้นหาจาก รหัสสมาชิก"
              onSearch={(value) => setSearch(value)}
              allowClear
            />
          </Col>
          <Col span={2} className="text-right">
            <Text strong>ประเภทรายการ</Text>
          </Col>
          <Col span={4}>
            <SelectOption
              className="w-100"
              defaultValue={transTypeFilter}
              options={transTypeOptions}
              onChange={(e) => setTransTypeFilter(e)}
            />
          </Col>
          <Col span={2} className="text-right">
            <Typography.Text strong className="text-nowrap">
              วันที่ดำเนินการ
            </Typography.Text>
          </Col>
          <Col span={6}>
            <DatePicker.RangePicker
              className="w-100"
              placeholder={["วันที่เริ่มต้น", "วันที่สิ้นสุด"]}
              format="DD/MM/YYYY"
              value={[date_from, date_to]}
              onChange={(e) => {
                setDateFrom(e[0] ? moment(e[0], "DD/MM/YYYY") : null);
                setDateTo(e[1] ? moment(e[1], "DD/MM/YYYY") : null);
              }}
            />
          </Col>
        </Row>

        <Table
          bordered
          size="small"
          dataSource={data?.data.length > 0 ? data?.data : []}
          rowKey="row_id"
          loading={loading}
          scroll={{ x: "max-content" }}
          pagination={{
            current: page,
            pageSize: limit,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} จากทั้งหมด ${total} รายการ`,
            total: data?.data.length,
            showLessItems: true,
            size: "default",
            onChange: (currPage) => setPage(currPage),
          }}
        >
          <Table.Column title="#" dataIndex="row_id" align="left" />
          <Table.Column
            title="วันที่ดำเนินการ"
            dataIndex="create_date"
            align="left"
            render={(text) =>
              text ? moment(text).format("DD/MM/YYYY HH:mm") : "-"
            }
          />
          <Table.Column
            title="ประเภทรายการ"
            dataIndex="trans_type"
            align="left"
            render={(text) => {
              if (text === "reserve") {
                return <Text style={{ color: "#00b4ac" }}>จองคะแนน</Text>;
              } else if (text === "cancel") {
                return <Text style={{ color: "#FF0000" }}>ยกเลิกการจอง</Text>;
              } else if (text === "bill") {
                return <Text>ปลดล็อก-เปิดบิล</Text>;
              } else {
                return <Text>{text}</Text>;
              }
            }}
          />
          <Table.Column
            title="คะแนน"
            dataIndex="rp"
            align="left"
            render={(text, record) => {
              const value = Number(text);
              const formatted = !isNaN(value)
                ? value.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : text;

              if (record.trans_type === "reserve") {
                return <Text style={{ color: "#00b4ac" }}>{formatted}</Text>;
              } else if (record.trans_type === "cancel") {
                return <Text style={{ color: "#FF0000" }}>{formatted}</Text>;
              } else {
                return <Text>{formatted}</Text>;
              }
            }}
          />
          <Table.Column
            title="ข้อมูลสมาชิกผู้ดำเนินการ"
            dataIndex="partner_name"
            render={(text, record) => {
              return `${record.partner_code ? record.partner_code : ""}  ${
                record.partner_name ? record.partner_name : ""
              }`;
            }}
            align="left"
          />

          <Table.Column
            title="รายละเอียด"
            dataIndex="description"
            align="left"
            onCell={() => ({
              style: {
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                maxWidth: 300,
              },
            })}
          />
          <Table.Column
            title="พนักงานผู้ดำเนินการ"
            dataIndex="create_by"
            align="left"
          />
        </Table>
      </PanelBody>
    </Panel>
  );
};

export default History;
